const curalate = ({ link }) => ({
    init() {
        if (Boolean(process.env.MIX_CRL8_SITENAME)) {
            const CRL8_SITENAME = process.env.MIX_CRL8_SITENAME;
            !function () { var e = window.crl8 = window.crl8 || {}, n = !1, i = []; e.ready = function (e) { n ? e() : i.push(e) }, e.pixel = e.pixel || function () { e.pixel.q.push(arguments) }, e.pixel.q = e.pixel.q || []; var t = window.document, o = t.createElement("script"), c = e.debug || -1 !== t.location.search.indexOf("crl8-debug=true") ? "js" : "min.js"; o.async = !0, o.src = t.location.protocol + "//edge.curalate.com/sites/" + CRL8_SITENAME + "/site/latest/site." + c, o.onload = function () { n = !0, i.forEach(function (e) { e() }) }; var r = t.getElementsByTagName("script")[0]; r.parentNode.insertBefore(o, r.nextSibling) }();

            // Workaround for link replacement of the View Gallery button
            const patterns = ['/', '/fr/', '/de/', '/pl/', '/us/']
            if (patterns.indexOf(location.pathname) !== -1) {
                const galleryButtonObserver = new MutationObserver(mutations => {
                    const galleryButton = document.querySelector('a[href="https://www.accu.co.uk/gallery"]')
                    if (galleryButton) {
                        galleryButton.setAttribute('href', link)
                        galleryButtonObserver.disconnect()
                    }
                });

                galleryButtonObserver.observe(document.querySelector('#curalate'), {
                    childList: true,
                    subtree: true
                });
            }
        }
    }
});
document.addEventListener('alpine:init', () => {
    window.Alpine.data('curalate', curalate)
})
